import { render, staticRenderFns } from "./GalleryDiaryIndex.vue?vue&type=template&id=28794e16"
import script from "./GalleryDiaryIndex.vue?vue&type=script&lang=js"
export * from "./GalleryDiaryIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports